import * as React from "react";
import { forwardRef } from "react";
const SvgGuide = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M10.667 17L14.0003 7", stroke: "#727272", strokeLinecap: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M17.3333 8.11108L20.6667 12L17.3333 15.8889M7.33333 8.11108L4 12L7.33333 15.8889", stroke: "#727272", strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgGuide);
export { ForwardRef as ReactComponent };
